import assetPath from '/app/packages/lebenslauf/articles/src/assets/kuendigung.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')